import styled from 'styled-components'
import { primaryColor } from '@/containers/App/globalStyles'

export const LabelTop = styled.span`
  color: ${primaryColor};
  font-size: 18px;
  font-weight: bold;
`
